import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'

const Highlight = ({ children, variant = [] }) => (
  <span className={withModifiers('highlight', variant, styles)}>
    <span className={styles.highlight__text}>{children}</span>
  </span>
)

export default Highlight
